(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('GtpAddController', GtpAddController);

    GtpAddController.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$translate', '$filter', 'OltService', 'GtpService', 'gtpId'];

    function GtpAddController($scope, $rootScope, $uibModalInstance, $translate, $filter, OltService, GtpService, gtpId) {

        // Variables
        var vm = this;
        vm.requestRunning = false;
        vm.arrayOlts = null;
        vm.arrayInputs = null;
        vm.oltModelIsIntelbras = null;
        vm.isEdit = !!gtpId;
        vm.modalTitle = vm.isEdit ? 'edit' : 'add';
        vm.labelButton = vm.isEdit ? 'save' : 'create';

        vm.gtpModel = {
            name: '',
            olt: '',
            gtpId: {value: ''},
            guaranteedUpstreamBw: {value: 0},
            trafficClass: 'UBR',
            compensated: false,
            shared: false,
            dbaEnabled: false,
            dbaFixedUsUbrBw: {value: 0},
            dbaFixedUsCbrBw: {value: 0},
            dbaAssuredUsBw: {value: 0},
            dbaMaxUsBw: {value: 0},
            dbaExtraUsBwType: 'BESTEFFORT'
        };

        // Validations
        var rules = GtpService.getRules();

        // Method apis
        vm.getAllOlt = getAllOlt;

        // Method handler
        vm.changeOlt = changeOlt;
        vm.changeSwitch = changeSwitch;
        vm.disableOrEnableInputs = disableOrEnableInputs;
        vm.validateRange = validateRange;
        vm.save = save;
        vm.close = close;
        vm.toggleSwitch = toggleSwitch;

        // Method apis
        function getAllOlt() {
            if (!vm.isEdit) {
                OltService.getOlt().then(successOlt).catch(errorOlt);
            }
        }

        function getOltById(oltId) {
            OltService.getOlt(oltId).then(successOlt).catch(errorOlt);
        }

        // Method handler
        function mainSettings() {
            if (vm.isEdit) {
                vm.requestRunning = true;
                GtpService.getGtp(gtpId).then(successGtp).catch(errorGtp);
            }
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function changeOlt(olt) {
            // Build the list of inputs that have value validation
            var inputs = angular.copy(vm.arrayInputs);
            inputs.unshift('gtpId', 'guaranteedUpstreamBw');

            // Validation rules to the selected OLT
            var oltRules = rules[olt.model];

            // Build the list of validation attributes
            var keys = Object.keys(oltRules.defaultBw);
            var rule = '', tooltip = '';

            // Set the validation rule for each input
            inputs.forEach(function (input) {
                // Check and set each validation rule
                keys.forEach(function (key) {
                    // Check if the rule exists for the field, else get the default value
                    rule = oltRules[input] && angular.isDefined(oltRules[input][key]) ? input : 'defaultBw';
                    // Set the right validation value in the model
                    vm.gtpModel[input][key] = oltRules[rule][key];
                });
                // Set the right tooltip for the field checking if it allow zero or not
                tooltip = 'tooltip.gtpBw' + (vm.gtpModel[input].allowZero ? '' : 'NonZero');
                $translate(tooltip, vm.gtpModel[input]).then(setTooltip(input));
            });

            // Set the tooltip for the gtpId field
            $translate('tooltip.gtpId', vm.gtpModel.gtpId).then(setTooltip('gtpId'));

            // Disable or enable inputs according to the OLT selected
            disableOrEnableInputs(olt);
        }

        function setTooltip(input) {
            return function (translation) {
                vm.gtpModel[input].tooltip = translation;
            }
        }

        function changeSwitch(switchField) {
            // Check if it is the DBA enabled switch
            if (switchField == 'dbaEnabled') {
                // Get the switch value
                var dbaEnabled = !!vm.gtpModel.dbaEnabled;
                // Get the Guaranteed bandwidth field
                var field = 'guaranteedUpstreamBw';
                // Set the Guaranteed bandwidth field tooltip according with DBA enabled value
                var tooltip = 'tooltip.gtpBw' + (dbaEnabled ? '' : 'NonZero');
                // Set the allowZero property of Guaranteed bandwidth field according with DBA enabled value
                vm.gtpModel[field].allowZero = rules.Zhone8820G[field].allowZero = dbaEnabled;
                // Set the tooltip translation
                $translate(tooltip, vm.gtpModel[field]).then(setTooltip(field));
            }
        }

        // Enable or Disable the inputs based in olt model type
        function disableOrEnableInputs(olt) {
            vm.oltModelIsIntelbras = olt.model == 'Intelbras8820i';
        }

        // Validate the value of the field according to the rules defined in its model
        function validateRange(key) {
            var input = vm.gtpModel[key];
            var valid = true;

            // Check if value is multiple of the value defined
            valid = valid && input.value !== 0 && (input.value % input.multiple) === 0;
            // Check if the value is in the range defined
            valid = valid && input.value >= input.min && input.value <= input.max;
            // Check if the value is zero, only if field has allowZero set to true
            if (input.allowZero) {
                valid = valid || input.value === 0
            }

            return valid;
        }

        function toggleSwitch(elementToggle) {
            if (elementToggle) {
                vm.gtpModel[elementToggle] = !vm.gtpModel[elementToggle];
            }
        }

        // Method Private
        function createArrayInputFields() {
            vm.arrayInputsSwitch = ['compensated', 'shared', 'dbaEnabled'];
            vm.arrayInputs = ['dbaFixedUsUbrBw', 'dbaFixedUsCbrBw', 'dbaAssuredUsBw', 'dbaMaxUsBw'];
        }

        function save() {
            if (vm.formGtpAdd.$valid && !vm.requestRunning) {
                vm.requestRunning = true;

                var data = {};
                var gtpModel = vm.gtpModel;

                var statusError = '';
                var sum = 0;
                var oltModel = gtpModel.olt.model;

                if (oltModel == 'Zhone8820G' && gtpModel.dbaEnabled) {
                    sum = gtpModel.dbaFixedUsUbrBw.value + gtpModel.dbaFixedUsCbrBw.value;
                    if (sum < rules[oltModel].defaultBw.min) {
                        statusError = '400.1';
                    }
                    sum += gtpModel.dbaAssuredUsBw.value;
                    if (sum > gtpModel.dbaMaxUsBw.value) {
                        statusError = '400.2';
                    }
                } else if (oltModel == 'Intelbras8820i') {
                    sum = gtpModel.dbaFixedUsUbrBw.value + gtpModel.dbaFixedUsCbrBw.value + gtpModel.dbaAssuredUsBw.value;
                    if (sum > gtpModel.dbaMaxUsBw.value) {
                        statusError = '400.3';
                    }
                    if (sum === 0 && gtpModel.dbaExtraUsBwType != 'BESTEFFORT') {
                        statusError = '400.4';
                    }
                }

                if (statusError) {
                    errorSaveGtp({status: statusError, config: {}});
                } else {
                    for (var field in gtpModel) {
                        if (gtpModel[field] && angular.isDefined(gtpModel[field].value)) {
                            data[field] = gtpModel[field].value;
                        } else {
                            data[field] = gtpModel[field];
                        }
                    }
                    data.name = gtpModel.name.toUpperCase();
                    data.oltId = gtpModel.olt.id;
                    if (gtpModel.olt.model == 'Intelbras8820i') {
                        delete data.guaranteedUpstreamBw;
                    }
                    delete data.olt;

                    if (vm.isEdit) {
                        data.id = gtpId;
                        GtpService.updateGtp(data).then(successSaveGtp).catch(errorSaveGtp);
                    } else {
                        GtpService.addGtp(data).then(successSaveGtp).catch(errorSaveGtp);
                    }
                }
            }
        }

        function successGtp(data) {
            for (var field in vm.gtpModel) {
                if (angular.isDefined(vm.gtpModel[field].value)) {
                    vm.gtpModel[field].value = data[field];
                } else {
                    vm.gtpModel[field] = data[field];
                }
            }
            vm.gtpModel.olt = {
                id: data.oltId,
                name: data.oltName
            };
            getOltById(data.oltId);
        }

        function errorGtp(errorType) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(errorType, 'get');
            close();
        }

        // Method response
        function successOlt(data) {
            vm.requestRunning = false;

            if (vm.isEdit) {
                vm.gtpModel.olt.model = data.model;
                changeOlt(data);
                changeSwitch('dbaEnabled');
            } else {
                vm.arrayOlts = data;
            }
        }

        function errorOlt(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'getOltList');
        }


        function successSaveGtp(data) {
            vm.requestRunning = false;
            var modalInstance = GtpService.successModalConstructor('save');
            modalInstance.result.finally(function () {
                if (vm.isEdit) {
                    $rootScope.$emit('gtpUpdateSuccess', data);
                } else {
                    $rootScope.$emit('gtpAddSuccess', data);
                    $rootScope.$emit('cleanFilter');
                }
            });
        }

        function errorSaveGtp(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'save');
        }

        function initialize() {
            createArrayInputFields();
            mainSettings();
            getAllOlt();
        }
        initialize();
    }
})();
